'use strict';

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

var DatadogSpanContext = require('../opentracing/span_context');

var priority = require('../../../../ext/priority');

var USER_REJECT = priority.USER_REJECT;

var NoopSpanContext =
/*#__PURE__*/
function (_DatadogSpanContext) {
  _inherits(NoopSpanContext, _DatadogSpanContext);

  function NoopSpanContext(props) {
    var _this;

    _classCallCheck(this, NoopSpanContext);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NoopSpanContext).call(this, props));
    _this._traceFlags.sampled = false;
    _this._sampling.priority = USER_REJECT;
    return _this;
  }

  return NoopSpanContext;
}(DatadogSpanContext);

module.exports = NoopSpanContext;